import React, { useState, useEffect } from "react";
import {
  Instagram,
  Facebook,
  Twitter,
  Youtube,
  LayoutGrid,
  Timer,
  Truck,
  BadgePercent,
} from "lucide-react";
import { ImagePath } from "../../assests";

const TopAnnouncementBar: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const announcements = [
    {
      icon: <LayoutGrid size={14} />,
      text: "Biggest pet store with 12,000+ products",
    },
    { icon: <Truck size={14} />, text: "Free delivery above AED 100" },

  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % announcements.length);
    }, 4000); // Change every 4 seconds
    return () => clearInterval(interval);
  }, [announcements.length]);

  return (
    <div className="w-full bg-mainBrandColor text-white py-1.5 px-6 flex items-center justify-between border-b border-white/5 overflow-hidden">
      {/* 1. LEFT SIDE: Static Utility Links (Clean typography) */}
      <div className="flex items-center gap-6 text-[11px] md:text-xs text-white font-medium">
        <a
          href="/aboutUs"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-white/80 transition-colors duration-200"
        >
          About
        </a>
        <a
          href="/faq"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-white/80 transition-colors duration-200"
        >
          FAQ
        </a>
        <a
          href="/contactus"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-white/80 transition-colors duration-200"
        >
          Contact Us
        </a>
      </div>

      {/* 2. MIDDLE: Horizontal Sliding Announcements (Friendly text) */}
      <div className="relative flex-1 max-w-lg flex items-center justify-center h-5 overflow-hidden">
        {announcements.map((item, index) => (
          <div
            key={index}
            className={`absolute flex items-center justify-center gap-2.5 w-full transition-all duration-700 ease-in-out transform text-xs md:text-[13px] font-medium tracking-tight
                            ${
                              index === currentIndex
                                ? "translate-x-0 opacity-100"
                                : index < currentIndex
                                ? "-translate-x-1/2 opacity-0" // Softer exit
                                : "translate-x-1/2 opacity-0" // Softer entrance
                            }`}
          >
            <span className="text-white/60">{item.icon}</span>
            <span className="whitespace-nowrap text-white">{item.text}</span>
          </div>
        ))}
      </div>

      {/* 3. RIGHT SIDE: Social Links (Small & subtle) */}
      <div className="flex items-center gap-4 border-l border-white/10 pl-5 ml-4">
        <a
          href="https://www.instagram.com/petland.dxb/?hl=en"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-5 h-5 text-white hover:scale-110 transition-all"
          aria-label="Instagram"
        >
          <Instagram size={14} />
        </a>

        <a
          href="https://www.youtube.com/@Petlandgroupofficial"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-5 h-5 text-white hover:scale-110 transition-all"
          aria-label="Youtube"
        >
          <Youtube size={18} />
        </a>

        <a
          href="https://www.facebook.com/p/Petland-100083613397937/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-5 h-5 text-white hover:scale-110 transition-all"
          aria-label="Facebook"
        >
          <img
            src={ImagePath.fb}
            alt="Facebook"
            className="w-[14px] h-[14px] object-contain"
          />
        </a>
      </div>
    </div>
  );
};

export default TopAnnouncementBar;
